import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface EventDetailsForm {
  title: string;
  location?: string;
  room?: string;
  instructor?: Array<string>;
  maxSize?: number;
  session?: string;
  hide?: boolean;
  autoHideAfterEnd?: boolean;
  autoHideGraceHours?: number;
  color?: string;
  costumeFee?: number;
  // startAge?: number;
  // endAge?: number;
  startYear?: number;
  endYear?: number;
  startMonth?: number;
  endMonth?: number;
  group?: Array<string>;
  tags?: Array<string>;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  duration?: string | number;
  days?: Array<string>;
  oneTime?: boolean;
  registrationStartDate?: string;
  registrationFeeAmount?: number;
  tuitionFee?: number;
  tuitionBillingCycle?: string;
  billingDay?: number;
  billingFrequencyDays?: number;
  prorateTuition?: boolean;
  description?: string;
  policyGroup?: Array<string>;
  displayOnWebsite?: boolean;
  allowPortalEnrollment?: boolean;
  allowOnlineRegistration?: boolean;
  allowTrialEnrollment?: boolean;
  allowSpecificDatesSelection?: boolean;
  includeInPublicSchedule?: boolean;
  availability: Array<{
    day: string;
    startTime: string;
    endTime: string;
  }>;
  timeConfig: string;
}

export const updateEventAPI = async (
  eventId: string,
  file: Blob | string | null,
  fileType: 'file' | 'url',
  eventDetails: EventDetailsForm,
) => {
  const formData = new FormData();

  if (fileType === 'file' && file instanceof Blob) {
    const filename =
      file instanceof File ? file.name : `event-cover-${Date.now()}.jpg`;
    formData.append('file', file, filename);
    formData.append('fileType', fileType);
  } else if (fileType === 'url' && typeof file === 'string') {
    formData.append('fileUrl', file);
    formData.append('fileType', fileType);
  }

  formData.append('payload', JSON.stringify(eventDetails));

  // Let the client set multipart boundary; manual Content-Type breaks parsing.
  const resp = await baseAPI.patch<unknown>(`/events/${eventId}`, formData);
  return resp.data;
};

export const useUpdateEventMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      eventId: string;
      file: Blob | string | null;
      fileType: 'file' | 'url';
      eventDetails: EventDetailsForm;
    }) => {
      const response = await updateEventAPI(
        params.eventId,
        params.file,
        params.fileType,
        params.eventDetails,
      );
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.EVENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.EVENTS, params.eventId],
      });
    },
  });
};
